import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { PoDisclaimer, PoDisclaimerGroup, PoInputComponent } from '@po-ui/ng-components';

@Component({
    selector: 'cp-inputdisclaimergroup',
    templateUrl: './cp-inputdisclaimergroup.component.html',
    standalone: false
})

export class CpInputDisclaimerGroupComponent implements OnInit {

  disclaimersGroup: Array<PoDisclaimer> = [];
  @Input() labelText: string = '';
  @Input() placeholder: string = '';
  @Input() icon: string = '';
  @Output() resultDisclaimers = new EventEmitter<Array<PoDisclaimer>>();
  @ViewChild('inputText', { static: true }) inputTextComponent: PoInputComponent;
  @ViewChild('disclaimerGroup', { static: true }) disclaimerGroupComponent: PoDisclaimerGroup;

  ngOnInit(): void {
    this.disclaimersGroup = new Array<PoDisclaimer>();
  }

  insertFilterDisclaimer(filter: string) {
    const filterDisclaimer: PoDisclaimer = {
      value: filter
    }
    if(filter && filterDisclaimer.value != '')
    {
      this.inputTextComponent.writeValue('');
      this.inputTextComponent.writeValueModel('');
      this.disclaimersGroup = [...this.disclaimersGroup, filterDisclaimer];
      this.resultDisclaimers.emit(this.disclaimersGroup);
    }
  }

  removeFilterDisclaimer()
  {
    this.resultDisclaimers.emit(this.disclaimersGroup);
  }

  removeAllFilters()
  {
    this.resultDisclaimers.emit(new Array<PoDisclaimer>());
  }

  clearDisclaimerGroup()
  {
    this.disclaimersGroup = new Array<PoDisclaimer>();
  }
}
